import PageShell from "@/components/site/PageShell";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePageContent } from "@/i18n/pageContent";

function renderInline(text) {
  if (!text) return null;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => p.startsWith("**") && p.endsWith("**")
    ? <strong key={i} className="text-[#1a365d]">{p.slice(2, -2)}</strong>
    : <span key={i}>{p}</span>);
}

export default function EUCEE() {
  const c = usePageContent("euCEE");
  return (
    <PageShell>
      {/* Full-width cinematic banner (preserves 2.86:1 UE-CEE artwork) */}
      <section className="relative w-full bg-[#0f2340] overflow-hidden">
        <img
          src="/eu-cee-hero.jpg"
          alt="UE - CEE"
          className="w-full h-auto block"
        />
      </section>

      {/* Editorial title block below the banner */}
      <section className="bg-[#fafaf7] border-b border-[#e2e8f0]/80">
        <div className="max-w-5xl mx-auto px-6 md:px-10 py-14 md:py-20 reveal">
          {c.eyebrow ? <span className="eyebrow">{c.eyebrow}</span> : null}
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl text-[#1a365d] leading-[1.04] tracking-tight mt-5">
            {c.titleA} <span className="italic">{c.titleB}</span>.
          </h1>
          {c.subtitle ? (
            <p className="font-body text-[#475569] text-base md:text-lg leading-relaxed max-w-2xl mt-6">
              {c.subtitle}
            </p>
          ) : null}
        </div>
      </section>

      <section className="bg-white py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-7 text-[#1e293b] leading-[1.9] text-base md:text-[17px]">
          <div className="reveal">
            <h2 className="font-display text-2xl md:text-3xl text-[#1a365d] mb-4 leading-tight">{c.s1Title}</h2>
            <p>{renderInline(c.s1P1)}</p>
            <p>{c.s1P2}</p>
          </div>
          <div className="reveal delay-1">
            <h2 className="font-display text-2xl md:text-3xl text-[#1a365d] mt-10 mb-4 leading-tight">{c.s2Title}</h2>
            <p>{renderInline(c.s2P1)}</p>
            <p>{c.s2P2}</p>
          </div>
          <blockquote className="border-l-2 border-[#d4af37] pl-6 my-10 font-display text-xl md:text-2xl text-[#1a365d] leading-[1.4] italic">
            {c.quote}
          </blockquote>
          <p className="reveal">{renderInline(c.closing)}</p>
          <div className="pt-6">
            <Link to="/road-to-27" className="btn-outline">
              The Road to 27 <ArrowRight size={14} strokeWidth={1.8} />
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
